import {useBuildOCRDetectedData as useSharedBuildOCRDetectedData} from '@chekin/shared/guest-form';
import {useSummary} from 'context/summary';

function useBuildOCRDetectedData() {
  const {countryCode} = useSummary();
  return useSharedBuildOCRDetectedData({countryCode});
}

export {useBuildOCRDetectedData};
export default useBuildOCRDetectedData;
